import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  woNumber: "",
  poNumber: "",
  customerName: "",
  ticketNumber: "",
};

export const HeaderSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setWONumber: (state, action) => {
      state.woNumber = action.payload;
    },
    setPONumber: (state, action) => {
      state.poNumber = action.payload;
    },
    setCustomerName: (state, action) => {
      state.customerName = action.payload;
    },
    setTicketNumber: (state, action) => {
      state.ticketNumber = action.payload;
    },
  },
});

export const { setWONumber, setPONumber, setCustomerName, setTicketNumber } = HeaderSlice.actions;

export default HeaderSlice.reducer;
